import { Box, Button, Stack, Typography } from '@mui/material';
import { timeSchemeIdToToggles, togglesToTimeSchemeId, timeFormatPreview } from '../resources/events-helpers';

const PARTS = ['HOURS', 'MINUTES', 'SECONDS', 'TENTHS', 'HUNDREDTHS'] as const;

interface TimeUnitToggleRowProps {
  value: string;
  onChange: (schemeId: string) => void;
  error?: boolean;
}

export const TimeUnitToggleRow = ({ value, onChange, error }: TimeUnitToggleRowProps) => {
  const selectedParts = timeSchemeIdToToggles(value);

  const handleToggle = (part: string) => {
    const next = selectedParts.includes(part)
      ? selectedParts.filter(p => p !== part)
      : [...selectedParts, part];
    onChange(togglesToTimeSchemeId(next));
  };

  const preview = timeFormatPreview(selectedParts);

  return (
    <Box sx={{ width: '100%', mt: 0.5 }}>
      <Typography variant="caption" color={error ? 'error' : 'text.secondary'} sx={{ display: 'block', mb: 0.5 }}>
        Time units (select at least one)
      </Typography>
      <Stack direction="row" spacing={0.5} flexWrap="wrap">
        {PARTS.map(part => (
          <Button
            key={part}
            variant={selectedParts.includes(part) ? 'contained' : 'outlined'}
            size="small"
            onClick={() => handleToggle(part)}
            sx={{ minWidth: 100, textTransform: 'none' }}
          >
            {part}
          </Button>
        ))}
      </Stack>
      {preview ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          Format: {preview}
        </Typography>
      ) : (
        <Typography variant="caption" color="warning.main" sx={{ display: 'block', mt: 0.5 }}>
          Select at least one unit
        </Typography>
      )}
    </Box>
  );
};
